<svg width="390" height="844" viewBox="0 0 390 844" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_236_36417)">
<rect width="390" height="844" fill="#230D93"/>
<mask id="mask0_236_36417" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="-43" width="390" height="887">
<rect x="390" y="844" width="390" height="887" rx="4.87804" transform="rotate(-180 390 844)" fill="#480D93"/>
</mask>
<g mask="url(#mask0_236_36417)">
<mask id="mask1_236_36417" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="-1" y="-43" width="391" height="887">
<rect x="-0.365234" y="-43" width="390" height="887" fill="#873CE5"/>
</mask>
<g mask="url(#mask1_236_36417)">
</g>
<mask id="mask2_236_36417" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="-100" y="-43" width="595" height="888">
<rect x="494.899" y="844.283" width="594.155" height="887.283" rx="4.87804" transform="rotate(-180 494.899 844.283)" fill="#873CE5"/>
</mask>
<g mask="url(#mask2_236_36417)">
<path d="M-124.474 1199.79C24.604 1199.79 145.409 1074.44 145.409 919.748C145.409 765.058 24.604 639.705 -124.474 639.705C-273.553 639.705 -394.357 765.058 -394.357 919.748C-394.357 1074.44 -273.553 1199.79 -124.474 1199.79Z" fill="#663CE5"/>
<path d="M197.819 703.103C346.897 703.103 467.702 577.751 467.702 423.06C467.702 268.37 346.897 143.018 197.819 143.018C48.7404 143.018 -72.0645 268.37 -72.0645 423.06C-72.0645 577.751 48.7404 703.103 197.819 703.103Z" fill="#663CE5"/>
<path d="M519.937 1199.79C669.015 1199.79 789.82 1074.44 789.82 919.748C789.82 765.058 669.015 639.705 519.937 639.705C370.859 639.705 250.054 765.058 250.054 919.748C250.054 1074.44 370.859 1199.79 519.937 1199.79Z" fill="#663CE5"/>
<path d="M338.593 1421.13C266.497 1291.45 228.629 1144.42 228.629 994.8V599.271H166.312V995.508C166.312 1144.89 128.331 1291.68 56.3481 1421.13H338.707H338.593Z" fill="#663CE5"/>
</g>
</g>
</g>
<defs>
<clipPath id="clip0_236_36417">
<rect width="390" height="844" fill="white"/>
</clipPath>
</defs>
</svg>
